import { render } from "./BulkActionSelector.vue?vue&type=template&id=6b892090"
import script from "./BulkActionSelector.vue?vue&type=script&lang=js"
export * from "./BulkActionSelector.vue?vue&type=script&lang=js"

import "./BulkActionSelector.vue?vue&type=style&index=0&id=6b892090&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__